/****************************************************************
 * CODE Engraving Configurator
 ****************************************************************/
 class EngravingConfigurator extends HTMLElement {
  constructor() {
    super();

    const self = this;

    self.engravingElement = this.querySelector('[data-engraving-sign-options]');
    self.activeTitle = self.engravingElement?.querySelector('[data-engraving-zodiac-title]');
    self.birthstoneTitles = self.engravingElement?.querySelectorAll('[data-engraving-birthstone-title]');
    self.pendantTitles = self.engravingElement?.querySelectorAll('[data-engraving-pendant-title]');
    self.typeSwitches = self.engravingElement?.querySelectorAll('[data-engraving-switch]');
    self.typeContainers = self.engravingElement?.querySelectorAll('[data-engraving-type]');
    self.engravingInline = self.engravingElement?.querySelectorAll('[data-engraving-inline]').length > 0;
    self.configuratorSlides = document.querySelectorAll('[data-product-engraving-image]');
    self.symbolItems = document.querySelectorAll('[data-symbol-item]');
    self.symbols = Array.from(self.symbolItems)?.map(element => element.getAttribute('data-symbol-item'));
    self.currentVariant = false;
    this.variantData = false;
    self.windowInnerWidth = window.innerWidth;

    self.keyupEvent = new Event('keyup');

    let defaultOptions = {
      defaultSize: '15%',
      defaultColor: '#2f2105',
      activeType: 1,
      soldOut: "Sold out",
      skuSoldout: []
    };

    let dataOptions = {};
    if (this?.dataset?.options) {
      dataOptions = JSON.parse(this.dataset.options);
    }

    let metaOptions = {};
    if (self.engravingElement) {
      metaOptions = self.engravingElement.dataset.engravingSignOptions;
    }

    self.options = {
      ...defaultOptions,
      ...dataOptions,
      ...metaOptions
    }
    self.optionValues = [];

    self.blackListArray = self.options.skuSoldout;

    // See if we have filters to use
    if (self.typeSwitches && self.typeSwitches.length > 0) {
      let filterCheck = false;
      let currentElem = false;

      self.typeSwitches.forEach((elem) => {
        if (elem.classList.contains('active')) {
          filterCheck = true;
          currentElem = elem;
        }
      })

      if (filterCheck && currentElem) {
        // See if we have an active item already
        self.options.activeType = currentElem?.dataset?.engravingSwitch;
      }
      else {
        // Otherwise take the first item
        self.options.activeType = self.typeSwitches[0].dataset.engravingSwitch;
      }
    }

    self.init();
  }

  /**
   * Init the product
   *
   * @return void
   * @access public
   */
  init() {
    const self = this;

    // Initialize event listeners for configurator inputs and symbols
    document.querySelectorAll('[data-engraving-configurator-item]').forEach((element) => {
      element.addEventListener('change', (event) => self.handleInputChanges(event));
      element.addEventListener('keyup', (event) => self.handleInputChanges(event));
      element.addEventListener('input', (event) => self.handleInputChanges(event));
    });

    self.symbolItems.forEach(function(element) {
      element.addEventListener('click', function(e) {
        e.preventDefault();

        const target = self.querySelector('[data-symbol-input]');
        const symbol = element.dataset.symbolItem;

        if (target && target.value.length < target.maxLength) {
          let cursorPos = target.selectionStart;
          let v = target.value;
          let textBefore = v.substring(0, cursorPos);
          let textAfter = v.substring(cursorPos, v.length);

          target.value = textBefore + symbol + textAfter;
          target.dispatchEvent(self.keyupEvent);
          target.focus();
        }
      });
    });

    // Bind events to a change or click events for SKU values
    document.querySelectorAll('[data-engraving-sku-value]').forEach((element) => {
      element.addEventListener('change', function(e) {
        self.updateSkuValue();
      });
      element.addEventListener('click', function(e) {
        self.updateSkuValue();
      });
    });
    document.querySelectorAll('[data-engraving-sku-select]').forEach((element) => {
      setTimeout(() => {
        self.resetEngravingSelect(element);
      }, 100);
      element.addEventListener('change', function(e) {
        self.updateSkuValue();
      });
      element.addEventListener('click', function(e) {
        self.updateSkuValue();
      });
    });

    document.addEventListener('variant-change', function() {
      self.updateSkuValue(true);
    });

    window.addEventListener('resize', (event) => {
      if (window.innerWidth != self.windowInnerWidth) {
        setTimeout(function() {
          self.windowInnerWidth = window.innerWidth;
          self.renderPreview();
        }, 100);
      }
    });

    if (self.typeSwitches) {
      self.typeSwitches.forEach((element) => {
        element.addEventListener('change', function(e) {
          self.options.activeType = e.currentTarget.dataset.engravingSwitch;
          self.renderPreview();
        });
        element.addEventListener('blur', function(e) {
          self.options.activeType = e.currentTarget.dataset.engravingSwitch;
          self.renderPreview();
        });
        element.addEventListener('click', function(e) {
          e.preventDefault();
          self.options.activeType = e.currentTarget.dataset.engravingSwitch;
          self.renderPreview();
        });
      });
    }

    self.updateSkuValue(true);
    self.renderPreview();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[data-product-variants-json]').textContent);
    return this.variantData;
  }

  updateMasterId() {
    this.getVariantData();
    const activeID = parseInt(document.querySelector('[name="id"]').value);

    this.currentVariant = this.variantData.find((variant) => {
      return variant.id === activeID;
    });
  }

  resetEngravingSelect(element) {
    const defaultOption = element.querySelector('[data-default-option]');
    if (element && defaultOption) {
      element.value = defaultOption.value;
    }
  }

  updateSkuValue(updateVariant = false) {
    let self = this;

    this.updateMasterId();
    let target = this.querySelector('[data-engraving-sku-format]');
    let valFormat;
    if (target) {
      valFormat = target.dataset.engravingSkuFormat;
    }
    let currentColor = '';
    let currentColorFull = '';

    // Get the current variant and check for the color
    let selectedItems = [
      ...this.querySelectorAll('[data-engraving-sku-value]:checked'),
      ...this.querySelectorAll('[data-engraving-sku-select]')
    ];

    // Get all items
    let allItems = this.querySelectorAll('[data-engraving-sku-value]');

    // Check if we have a SKU value we can work with
    if (this?.currentVariant?.sku) {
      let currentSku = this.currentVariant.sku.toUpperCase();

      if (currentSku.indexOf('ROSEGOLD') !== -1 || currentSku.indexOf('OLR-') !== -1 || currentSku.indexOf('RCR-') !== -1) {
        currentColor = 'R'
        currentColorFull = 'RoseGold';
      }
      else if (currentSku.indexOf('GOLD') !== -1 || currentSku.indexOf('OLG-') !== -1 || currentSku.indexOf('RCG-') !== -1 || currentSku.indexOf('RFACG-') !== -1) {
        currentColor = 'G';
        currentColorFull = 'Gold';
      }
      else if (currentSku.indexOf('SILVER') !== -1 || currentSku.indexOf('OLS-') !== -1 || currentSku.indexOf('RCS-') !== -1 || currentSku.indexOf('RFACS-') !== -1) {
        currentColor = 'S';
        currentColorFull = 'Silver';
      }
    }

    // Check if specific charms or hangers are sold out
    if (updateVariant && self.blackListArray.length > 0) {

      allItems.forEach((elem) => {
        let fullSku = 'CH-'+currentColorFull+'-'+elem.dataset.engravingSkuValue;

        if (valFormat && valFormat.indexOf('[COLOR') >= 0) {
          if (self.pendantTitles && self.pendantTitles.length > 0 && !self.engravingInline) {
            fullSku = 'PE-'+currentColorFull+'-'+elem.dataset.engravingSkuValue;
          }
        }

        // remove all disabled properties
        elem.disabled = false;
        let currentText = elem.innerHTML;
        let soldOutText = ' (' + self.options.soldOut + ')';
        let newText = currentText.replace(soldOutText, '');
        let resetParent = false;
        let dataSkuFormat = elem.dataset.skuFormat || false;

        // Build up the value of the SKU
        if (dataSkuFormat) {
          let skuValue = elem.dataset.engravingSkuValue;
          dataSkuFormat = dataSkuFormat.replace('[SKUVALUE]', skuValue).toLowerCase();
        }

        if (self.blackListArray.includes(fullSku.toLowerCase()) || self.blackListArray.includes(dataSkuFormat)) {
          elem.disabled = true;
          newText += soldOutText;

          // In case of a select, only reset when the current selected value is sold out
          if (this.matches('option')) {
            resetParent = true;
          }
          else {
            resetParent = true;
            elem.checked = false;
          }
        }

        // Update the text in this item
        if (elem.matches('option')) {
          elem.innerHTML = newText;
        }

        if (resetParent) {
          if (elem.closest('select')) {
            elem.closest('select').selectedIndex = 0;
          }

          // Also clear the value from the form input to be sure
          if (target) {
            target.value = '';
          }
        }

      });
    }

    // Get the current variant and check for the color
    selectedItems.forEach((elem) => {

      let skuVal = '';
      if (elem.matches('select')) {
        skuVal = elem.options[elem.selectedIndex].dataset.engravingSkuValue;
      } else {
        skuVal = elem.dataset.engravingSkuValue;
      }

      let selectedParent = elem.parentNode;
      let selectedTarget = selectedParent.querySelector('[data-engraving-sku-format]');

      // Check if we have a SKU value we can work with
      if (this?.currentVariant?.sku) {

        if (selectedTarget) {
          let valFormat = selectedTarget.dataset.engravingSkuFormat;

          // See if we have custom formatting for this specific item
          if (elem.matches('select') && elem.options[elem.selectedIndex].dataset.skuFormat) {
            valFormat = elem.options[elem.selectedIndex].dataset.skuFormat;
          }

          // Build up the SKU for the charm
          valFormat = valFormat.replace('[COLOR]', currentColor)
                               .replace('[COLORFULL]', currentColorFull)
                               .replace('[SKUVALUE]', skuVal);
          selectedTarget.value = valFormat;
        }
      }
    });

    self.renderPreview(currentColorFull);
  }

  /**
   * handleInputChanges
   * @description Handle changes to configurator inputs
   * @param {Event} e - event
   */
  handleInputChanges(e) {
    const self = this;

    const elem = e.target;
    let i = elem.dataset.engravingConfiguratorItem;

    if (elem.dataset.engravingZodiacPreview) {
      self.activeTitle.value = elem.dataset.engravingZodiacPreviewTitle;
      self.optionValues[i] = elem.dataset.engravingZodiacPreview;
    }
    else if (elem.matches('select')) {
      self.optionValues[i] = elem.options[elem.selectedIndex].value;
    }
    else {
      const isInputWithSymbols = elem.hasAttribute('data-symbol-input');
      self.optionValues[i] = !isInputWithSymbols ? elem.value : self.inputWithoutInvalidCharacters(elem);
    }

    // Restrict input length to maxLength attribute (already done in HTML but added with JS since some users can still surpass it)
    if (elem.maxLength > -1 && elem.value.length > elem.maxLength) {
      elem.value = elem.value.slice(0, elem.maxLength);
    }

    self.renderPreview();
  }

  /**
   * inputWithoutInvalidCharacters
   * @description Remove invalid characters from the input and return the cleaned value
   * @param {Object} elem - The input element to clean
   */
  inputWithoutInvalidCharacters(elem) {
    const self = this;

    // create a regex for the accepted characters (numbers, letters, punctuation, <3 and the symbols from the symbols array)
    const acceptedCharactersRegex = new RegExp(`(?!<3)[\\w\\s.,!?;:'"\\[\\](){}<>\\-+=@#$%^&*\\\\/${self.symbols.join('')}]`, 'g');

    // remove all characters that are not in the accepted characters regex
    elem.value = elem.value.match(acceptedCharactersRegex)?.join('') || '';

    return elem.value;
  }

  renderPreview() {
    let self = this;
    let i = 1;
    let itemStyle, currentColor = '', currentColorFull = '', fontColor, fontSize, slideHeight, transforms = [];

    // Render the right zodiac signs and containers
    if (self.typeSwitches && self.typeSwitches.length > 0) {

      self.typeSwitches.forEach((elem) => {
        elem.classList.remove('active');

        if (elem.dataset?.engravingSwitch == self.options.activeType) {
          elem.classList.add('active');
        }
      });

      self.typeContainers.forEach((elem) => {
        elem.style.display = 'none';

        if (elem.dataset?.engravingType == self.options.activeType) {
          elem.style.display = 'block';
        }
      });
    }

    // Remove any possible content preview in there
    document.querySelectorAll('.engraving-configurator-preview').forEach((elem) => {
      elem.remove();
    });

    while(self.hasAttribute('data-engraving-configurator-option'+i)) {
      // Build up the styles from the metafield values
      // Set the default values, they will be overwritten if a metafield exists
      let itemStyle = '';
      let fontSize = parseFloat(self.options.defaultSize.replace('%', '')) / 100;
      let fontColor = self.options.defaultColor;
      let transforms = ['translateX(-50%)','translateY(-50%)'];
      let slideHeight = 0;

      if (('engravingConfiguratorOption'+i+'Left') in self.dataset) {
        itemStyle += 'left: ' + self.dataset['engravingConfiguratorOption'+i+'Left'].replace(',', '.') + ';';
      }
      if (('engravingConfiguratorOption'+i+'Top') in self.dataset) {
        itemStyle += 'top: ' + self.dataset['engravingConfiguratorOption'+i+'Top'].replace(',', '.') + ';';
      }
      if (('engravingConfiguratorOption'+i+'Style') in self.dataset) {
        itemStyle += 'font-style: ' + self.dataset['engravingConfiguratorOption'+i+'Style'] + ';';
      }
      if (('engravingConfiguratorOption'+i+'Rotate') in self.dataset) {
        transforms.push('rotate(' + self.dataset['engravingConfiguratorOption'+i+'Rotate'] + ')');
      }
      if (('engravingConfiguratorOption'+i+'Size') in self.dataset) {
        fontSize = parseFloat(self.dataset['engravingConfiguratorOption'+i+'Size'].replace('%', '') / 100);
      }
      if (('engravingConfiguratorOption'+i+'Color') in self.dataset) {
        fontColor = self.dataset['engravingConfiguratorOption'+i+'Color'];
      }

      self.configuratorSlides.forEach((elem) => {
        elem.querySelectorAll('figure').forEach((fig) => {
          if (fig.offsetHeight > slideHeight) {
            slideHeight = fig.offsetHeight;
          }
        });
      });

      const calcSize = slideHeight * fontSize;

      // Complete the style string to supply this preview
      itemStyle += 'color: ' + fontColor + ';';
      itemStyle += 'font-size: ' + Math.round(calcSize) + 'px;';
      itemStyle += 'transform: ' + transforms.join(' ')+';'

      // Check if we are in a zodiac configurator
      let extraClass = '';
      if (self.engravingElement) {
        extraClass = 'zodiac';
      }

      // Check if we are previewing birthstones or pendants
      let optionValue = '';
      if ((self.birthstoneTitles && self.birthstoneTitles.length > 0) || (self.pendantTitles && self.pendantTitles.length > 0)) {

        let checkedInput;
        itemStyle += 'height: ' + Math.round(calcSize) + 'px;';

        // Check if we have a SKU value we can work with
        if (this?.currentVariant?.sku) {
          let currentSku = this.currentVariant.sku.toUpperCase();

          if (currentSku.indexOf('ROSEGOLD') !== -1 || currentSku.indexOf('OLR-') !== -1 || currentSku.indexOf('RCR-') !== -1) {
            currentColor = 'R'
            currentColorFull = 'RoseGold';
          }
          else if (currentSku.indexOf('GOLD') !== -1 || currentSku.indexOf('OLG-') !== -1 || currentSku.indexOf('RCG-') !== -1 || currentSku.indexOf('RFACG-') !== -1) {
            currentColor = 'G';
            currentColorFull = 'Gold';
          }
          else if (currentSku.indexOf('SILVER') !== -1 || currentSku.indexOf('OLS-') !== -1 || currentSku.indexOf('RCS-') !== -1 || currentSku.indexOf('RFACS-') !== -1) {
            currentColor = 'S';
            currentColorFull = 'Silver';
          }
        }

        // Check if options are for birthstones or pendants
        if (self.birthstoneTitles && self.birthstoneTitles.length > 0) {
          extraClass = 'birthstone';
          checkedInput = document.querySelector('[data-birthstone-number-'+i+']:checked');

          if (checkedInput) {
            let checkedLabel = checkedInput.parentNode.querySelector('label[for='+checkedInput.id+']');
            let image = checkedLabel.querySelector('img');
            optionValue = image.outerHTML;
          }
        } else {
          extraClass = 'pendant';
          const pendantSelect = document.querySelector('[data-pendant-number-'+i+']');
          const selectedOption = pendantSelect.options[pendantSelect.selectedIndex];
          const previewImagesContainer = document.querySelector('[data-pendant-preview-images]');
          const selectedPreviewContainer = previewImagesContainer.querySelector('[data-pendant-preview="'+selectedOption.dataset?.imageId+'"]');
          let currentColorLowercase = '';
          if (typeof currentColorFull !== 'undefined') {
            currentColorLowercase = currentColorFull.toLowerCase();
          } else {
            console.log('Color match not found in variant SKU');
            return;
          }

          if (selectedPreviewContainer && currentColorLowercase !== '') {
            const previewImage = selectedPreviewContainer.querySelector('[data-pendant-color="'+currentColorLowercase+'"]');
            if (previewImage) {
              optionValue = previewImage.outerHTML;
            } else {
              console.log('Preview image not found');
            }
          }
        }

      } else {
        if (self.optionValues[i]) {
          for (let j = 0; j < self.optionValues[i].length; j++) {
            let char = self.optionValues[i][j];

            if (self.checkASCII(char)) {
              optionValue += char;
            }
            else {
              optionValue += '<span class="special">'+char+'</span>';
            }
          }
        }
      }

      // Add the preview box to all related slides
      self.configuratorSlides.forEach((elem) => {
        elem.querySelector('figure').innerHTML += '<div class="engraving-configurator-preview '+extraClass+'" style="'+itemStyle+'">'+optionValue+'</div>';
      });
      i++;
    }
  }

  checkASCII(str) {
    return str.charCodeAt(0) < 169;
  }
}

if (!customElements.get('engraving-configurator')) {
  customElements.define('engraving-configurator', EngravingConfigurator);
}
